import { IconType } from "./icons.types";

export const StoreIcon = ({ className, color = "#000000" }: IconType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <ellipse
        cx="10"
        cy="13.75"
        rx="5"
        ry="2.08333"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <ellipse
        cx="10"
        cy="6.66663"
        rx="2.5"
        ry="2.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.62892 10.9185C4.48493 10.9391 3.42303 11.1326 2.60859 11.4584C2.17929 11.6301 1.78154 11.8534 1.47885 12.1396C1.17458 12.4274 0.916748 12.8305 0.916748 13.3333C0.916748 13.8361 1.17458 14.2392 1.47885 14.5269C1.78154 14.8132 2.17929 15.0364 2.60859 15.2081C3.0782 15.396 3.63009 15.5399 4.23255 15.632C3.69702 15.1138 3.37585 14.5169 3.33733 13.8797C3.27801 13.8589 3.22076 13.8375 3.16568 13.8154C2.84096 13.6855 2.62852 13.5496 2.50952 13.4371C2.45658 13.387 2.43252 13.3524 2.42206 13.3333C2.43252 13.3142 2.45658 13.2795 2.50952 13.2295C2.62852 13.1169 2.84096 12.981 3.16568 12.8511C3.29722 12.7985 3.44113 12.7493 3.59605 12.7043C3.95765 12.0024 4.67407 11.3853 5.62892 10.9185ZM2.41462 13.3508C2.4145 13.3508 2.41474 13.3494 2.41574 13.3467C2.41526 13.3494 2.41475 13.3508 2.41462 13.3508ZM2.41574 13.3199C2.41474 13.3172 2.4145 13.3158 2.41462 13.3158C2.41475 13.3158 2.41526 13.3172 2.41574 13.3199Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6627 13.8797C16.6242 14.5169 16.303 15.1138 15.7675 15.632C16.3699 15.5399 16.9218 15.396 17.3914 15.2081C17.8207 15.0364 18.2185 14.8132 18.5212 14.5269C18.8254 14.2392 19.0833 13.8361 19.0833 13.3333C19.0833 12.8305 18.8254 12.4274 18.5212 12.1396C18.2185 11.8534 17.8207 11.6301 17.3914 11.4584C16.577 11.1326 15.5151 10.9391 14.3711 10.9185C15.3259 11.3853 16.0424 12.0024 16.404 12.7043C16.5589 12.7493 16.7028 12.7985 16.8343 12.8511C17.159 12.981 17.3715 13.1169 17.4905 13.2295C17.5434 13.2795 17.5675 13.3142 17.578 13.3333C17.5675 13.3524 17.5434 13.387 17.4905 13.4371C17.3715 13.5496 17.159 13.6855 16.8343 13.8154C16.7793 13.8375 16.722 13.8589 16.6627 13.8797ZM17.5854 13.3508C17.5853 13.3508 17.5848 13.3494 17.5843 13.3467C17.5853 13.3494 17.5855 13.3508 17.5854 13.3508ZM17.5843 13.3199C17.5848 13.3172 17.5853 13.3158 17.5854 13.3158C17.5855 13.3158 17.5853 13.3172 17.5843 13.3199Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8143 8.3465C13.6079 8.81451 13.3178 9.23736 12.9631 9.59612C13.3175 9.80006 13.7285 9.91671 14.1668 9.91671C15.5014 9.91671 16.5834 8.83473 16.5834 7.50004C16.5834 6.16535 15.5014 5.08337 14.1668 5.08337C14.0639 5.08337 13.9626 5.0898 13.8631 5.10227C14.0491 5.561 14.1557 6.06038 14.1659 6.58337C14.1662 6.58337 14.1665 6.58337 14.1668 6.58337C14.673 6.58337 15.0834 6.99378 15.0834 7.50004C15.0834 8.0063 14.673 8.41671 14.1668 8.41671C14.0419 8.41671 13.9228 8.39173 13.8143 8.3465Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.13707 5.10227C6.03761 5.0898 5.93626 5.08337 5.83341 5.08337C4.49873 5.08337 3.41675 6.16535 3.41675 7.50004C3.41675 8.83473 4.49873 9.91671 5.83341 9.91671C6.27165 9.91671 6.68264 9.80006 7.03703 9.59612C6.68232 9.23736 6.39229 8.81451 6.18588 8.3465C6.07737 8.39173 5.95831 8.41671 5.83341 8.41671C5.32715 8.41671 4.91675 8.0063 4.91675 7.50004C4.91675 6.99378 5.32715 6.58337 5.83341 6.58337C5.83369 6.58337 5.83396 6.58337 5.83423 6.58337C5.84449 6.06038 5.95111 5.561 6.13707 5.10227Z"
        fill={color}
      />
    </svg>
  );
};
